import React, { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert, Button } from 'shared/ui'
import { IntegrationSettingsPropertyDropdown } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSettingsPropertyDropdown/IntegrationSettingsPropertyDropdown'
import { IntegrationSettingsPropertyTable } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSettingsPropertyTable/IntegrationSettingsPropertyTable'
import { type IntegrationSettingsPropertyStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsPropertyStore'
import styles from './styles.module.scss'

type IIntegrationSettingsPropertyProps = {
  store: IntegrationSettingsPropertyStore
  is_1_0_request?: boolean
}

export const IntegrationSettingsProperty: FC<IIntegrationSettingsPropertyProps> = observer(
  ({ store, is_1_0_request }) => {
    const {
      rows,
      showSaveControl,
      saveNewProperties,
      clearNewProperties,
      loading,
      customPropertyStore,
      integrationName,
      hasHubspot,
    } = store

    return (
      <>
        {hasHubspot && (
          <Alert
            item={{
              type: 'infoBlue',
              title: `Custom mapped properties only sync from Salesmsg to ${integrationName}`,
            }}
            className={styles.alert}
          />
        )}

        <div className={styles.root}>
          <IntegrationSettingsPropertyTable
            rows={rows}
            loading={loading}
            integrationName={integrationName}
            integrationIcon={store.integrationIcon}
            is_1_0_request={is_1_0_request}
          />
          {!customPropertyStore.withoutPropertiesMapping && (
            <div className={styles.footer}>
              <IntegrationSettingsPropertyDropdown store={customPropertyStore} rows={rows} />
              {showSaveControl && (
                <div className={styles.control}>
                  <Button
                    text='Cancel'
                    typeBtn='contained'
                    contained='secondary'
                    size='medium'
                    onClick={clearNewProperties}
                  />
                  <Button
                    text='Save'
                    typeBtn='contained'
                    contained='primary'
                    size='medium'
                    onClick={() => saveNewProperties(is_1_0_request)}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </>
    )
  }
)
